<template>
  <div>
    <HMModalHeader :title="$t(titleKey)" @close="$emit('close')" />
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="confirm" v-if="productTagModel">
        <div class="row">
          <div class="col-12">
            <HMTextInput
              :label="$t('PRODUCTS.PRODUCT_TAGS.NAME')"
              v-model="productTagModel.name"
              rules="required"
              name="Product tag name"
            />
          </div>
        </div>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('GENERAL.BUTTON.SAVE')"
          :disabled="invalid"
          :formError="formError"
          @close="$emit('close')"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'ProductTagDialog',
  components: {
    ValidationObserver,
  },
  props: {
    productTag: {
      type: Object,
      default() {
        return {
          name: '',
        };
      },
    },
    onConfirm: null,
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
    }),
    titleKey() {
      return this.productTagModel?.id
        ? 'PRODUCTS.TITLE.EDIT_PRODUCT_TAG'
        : 'PRODUCTS.TITLE.ADD_PRODUCT_TAG';
    },
  },
  data() {
    return {
      productTagModel: null,
      formError: null,
    };
  },
  methods: {
    confirm() {
      this.onConfirm(this.productTagModel);
      this.$emit('close');
    },
  },
  mounted() {
    this.productTagModel = cloneDeep(this.productTag);
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.clickable {
  cursor: pointer;
  color: $medium-gray;
  &:hover {
    color: var(--brand-color, $coral);
  }
}

.info-box {
  border-radius: $border-radius;
  background-color: lighten($blue, 30%);
  padding: 0.5rem;

  .info {
  }
}
</style>
